import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { StatoInvioResponseDto } from '../model/StatoInvioResponseDto';
import { InvioDatiRequest } from '../model/Models';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  private baseUrl = environment.apiUrl + '/v1/';

  private uploadFilesTerritorialiUrl = 'files/territoriali/upload';
  private uploadFilesSemiresidenzialiUrl = 'files/semiresidenziali/upload';
  private inviadatiregioneUrl = 'files/inviadatiregione';
  private getIstanzaFlussoUrl = 'files/getistanzaflusso';
  private getDataScadenzaFlussoUrl = 'files/getdatascadenzaflusso';
  private checkStandardPositiveUrl = 'files/checkstandardpositive';
  private getContattiUrl = 'files/getcontatti';
  private getContattiIcd10Url = 'files/getcontattiicd10';
  private getAnagraficheUrl = 'files/getanagrafiche';
  private getPrestazioniUrl = 'files/getprestazioni';
  private getHistoryUrl = 'files/getSendedHistory';
  private downloadCsvUrl = 'file/get';
  private downloadFileTrasmissioneUrl = 'file/getTrasmissione';

  constructor(private httpClient: HttpClient) { }

  uploadFilesTerritoriali(codiceStruttura: string, anagFile: File | undefined, contattoFile: File | undefined,
    prestazioneFile: File | undefined, diagnosiFile: File | undefined, interventoFile: File | undefined) {

    const fileInput: any = new FormData();

    fileInput.append('codiceStruttura', codiceStruttura);
    fileInput.append('anagraficaFile', anagFile);
    fileInput.append('contattoFile', contattoFile);
    fileInput.append('prestazioneFile', prestazioneFile);
    fileInput.append('diagnosiFile', diagnosiFile);
    fileInput.append('interventoFile', interventoFile);

    return this.httpClient.post<any>(this.baseUrl + this.uploadFilesTerritorialiUrl, fileInput);
  }

  uploadFilesSemiresidenziali(codiceStruttura: string, anagFile: File | undefined, contattoFile: File | undefined, presenzaFile: File | undefined, prestazioneFile: File | undefined) {

    const fileInput: any = new FormData();

    fileInput.append('codiceStruttura', codiceStruttura);

    if (anagFile != undefined) {
      fileInput.append('anagraficaFile', anagFile);
    }
    if (contattoFile != null) {
      fileInput.append('contattoFile', contattoFile);
    }
    if (presenzaFile != null) {
      fileInput.append('presenzaFile', presenzaFile);
    }
    if (prestazioneFile != null) {
      fileInput.append('prestazioneFile', prestazioneFile);
    }

    return this.httpClient.post<any>(this.baseUrl + this.uploadFilesSemiresidenzialiUrl, fileInput);
  }

  inviaDatiRegione(request: InvioDatiRequest) {
    return this.httpClient.post<any>(this.baseUrl + this.inviadatiregioneUrl, request);
  }

  getCsvFile() {
    return this.httpClient.get<File>(this.baseUrl + this.downloadCsvUrl);
  }

  download(codStruttura: string): Observable<Blob> {
    return this.httpClient.get(this.baseUrl + this.downloadCsvUrl + '?codStruttura=' + codStruttura, {
      responseType: 'blob'
    });
  }

  getIstanzaFlusso(anno: string, flusso: string, etichetta: string, struttura: string, asl?: string) {
    let url = this.baseUrl + this.getIstanzaFlussoUrl + '?anno=' + anno + '&flusso=' + flusso + '&etichetta=' + etichetta
      + '&struttura=' + struttura + '&asl=' + asl;
    return this.httpClient.get(url);
  }

  getDataScadenzaFlusso(id: number) {
    let url = this.baseUrl + this.getDataScadenzaFlussoUrl + '?idistanzaflusso=' + id;
    return this.httpClient.get(url);
  }

  checkStandardPositiveTransmission(anno: string, flusso: string, etichetta: string, struttura: string, asl?: string) {
    let url = this.baseUrl + this.checkStandardPositiveUrl + '?anno=' + anno + '&flusso=' + flusso + '&etichetta=' + etichetta
      + '&struttura=' + struttura + '&asl=' + asl;
    return this.httpClient.get(url);
  }

  getContatti(anno: string, flusso: string, dataRifDa: string, dataRifA: string, struttura: string, asl?: string) {
    let url = this.baseUrl + 
      this.getContattiUrl + 
      '?anno=' + anno + 
      '&flusso=' + flusso + 
      '&dataRifDa=' + dataRifDa + 
      '&dataRifA=' + dataRifA + 
      '&struttura=' + struttura + 
      '&asl=' + asl;
    return this.httpClient.get(url, { responseType: 'text' });
  }

  getContattiIcd10(anno: string, flusso: string, dataRifDa: string, dataRifA: string, struttura: string, asl?: string) {
    let url = this.baseUrl + this.getContattiIcd10Url +
      '?anno=' + anno + 
      '&flusso=' + flusso + 
      '&dataRifDa=' + dataRifDa + 
      '&dataRifA=' + dataRifA + 
      '&struttura=' + struttura + 
      '&asl=' + asl;
    return this.httpClient.get(url, { responseType: 'text' });
  }

  getAnagrafiche(anno: string, flusso: string, dataRifDa: string, dataRifA: string, struttura: string, asl?: string) {
    let url = this.baseUrl + this.getAnagraficheUrl +
      '?anno=' + anno + 
      '&flusso=' + flusso + 
      '&dataRifDa=' + dataRifDa + 
      '&dataRifA=' + dataRifA + 
      '&struttura=' + struttura + 
      '&asl=' + asl;
    return this.httpClient.get(url, { responseType: 'text' });
  }

  getPrestazioni(anno: string, flusso: string, dataRifDa: string, dataRifA: string, struttura: string, asl?: string) {
    let url = this.baseUrl + this.getPrestazioniUrl + 
      '?anno=' + anno + 
      '&flusso=' + flusso + 
      '&dataRifDa=' + dataRifDa + 
      '&dataRifA=' + dataRifA + 
      '&struttura=' + struttura + 
      '&asl=' + asl;
    return this.httpClient.get(url, { responseType: 'text' });
  }

  public getStorico(
    dimensionePaginaSelezinata: number,
    numeroPaginaSelezionata: number,
    orderByName: string | null,
    orderByDirection: string | null,
    anno?: string,
    asl?: string,
    siglaFlusso?: string,
    periodo?: string
  ) {
    let url = this.baseUrl + this.getHistoryUrl;
    url += '?numeroPagina=' + numeroPaginaSelezionata;
    url += '&dimensionePagina=' + dimensionePaginaSelezinata;
    
    if (orderByName) url += '&orderByName=' + orderByName;
    if (orderByDirection) url += '&orderByDirection=' + orderByDirection;
    if (anno) url += '&anno=' + anno;
    if (asl) url += '&asl=' + asl;
    if (siglaFlusso) url += '&siglaFlusso=' + siglaFlusso;
    if (periodo) url += '&periodo=' + periodo;

    return this.httpClient.get(url);
  }

  downloadFileTrasmissione(idTrasmissione: number | undefined, fileName: string | undefined): Observable<Blob> {
    let url = this.baseUrl + this.downloadFileTrasmissioneUrl;
    url += '?idTrasmissione=' + idTrasmissione;
    url += '&fileName=' + fileName;
    return this.httpClient.get(url, {
      responseType: 'blob'
    });
  }

  getStatoInvio(idIstanzaInvio: number): Observable<StatoInvioResponseDto> {
    let url = this.baseUrl + 'trasmissione-flusso/stato-invio/' + idIstanzaInvio;
    return this.httpClient.get<StatoInvioResponseDto>(url);
  }
}